import React from 'react';

import { useCurrentUserPermissions } from 'src/hooks/user';
import { NotFoundErrorPage } from 'src/pages/not-found';

import { PeosDetailLayoutCVStaff } from './PeosDetailLayoutCVStaff';
import { PeosDetailLayoutPeoPayrollProviderStaff } from './PeosDetailLayoutPeoPayrollProviderStaff';

export const PeosDetailLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { hasPlatformRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (hasPlatformRoles) {
    return <PeosDetailLayoutCVStaff>{children}</PeosDetailLayoutCVStaff>;
  }

  if (isPeoPayrollProviderUser) {
    return (
      <PeosDetailLayoutPeoPayrollProviderStaff>{children}</PeosDetailLayoutPeoPayrollProviderStaff>
    );
  }

  return <NotFoundErrorPage />;
};
